export const scrollMainContent = () => {
    const parent = document.getElementById('mainContent');
    parent?.scrollTo({
        top: parent.scrollHeight,
        behavior: 'smooth',
    });
};
